import React from "react";
import { useSelector } from "react-redux";
import { strings } from "../../common/i18n";
import { BranchForm } from "../../common/components";
import useColumnsRows from "./useColumnsRows";
import MenuOptions from "../components/common/MenuOptions";
import MatReactTable from "../../common/components/MaterialReactTable";

/**
 * Branches Table Component
 */
export default () => {
    const { branches } = useSelector((state) => state);

    const {
        columns,
        error,
        data,
        rowActions,
        onCsvMap,
        onCsvUpload,
        onDataMap,
        onDataItemAdd,
        onDataItemClear,
        onDataItemSet,
        onDataSave,
        optionOpen,
        onMenuOpen,
        onMenuClose,
        toolBarComponents
    } = useColumnsRows();

    return (
        <>
            <MatReactTable
                persistKey="manageBranches"
                columns={columns}
                data={data}
                loading={false}
                rowActions={rowActions}
                toolBarComponents={toolBarComponents}
                noRowsMessage={strings("messages.noAssets")}
            />

            <MenuOptions
                columns={columns}
                data={data}
                header={strings("branch")}
                optionOpen={optionOpen}
                onMenuOpen={onMenuOpen}
                onMenuClose={onMenuClose}
                error={error}
                csvFileName={strings("branches")}
                onCsvMap={onCsvMap}
                onCsvUpload={onCsvUpload}
                onDataMap={onDataMap}
                onDataItemAdd={onDataItemAdd}
                onDataItemClear={onDataItemClear}
                onDataItemSet={onDataItemSet}
                onDataSave={onDataSave}
                dataItem={branches.item}
                FormComponent={BranchForm}
            />
        </>
    );
};
